import { useState } from 'react';
import type { SweepNotification } from '../../reducers/notificationsReducer';
import useAgentFilesNotifications from '../aiAgentCenter/useAgentFilesNotifications';

const usePersistentNotifications = (): SweepNotification[] => {
  const [dismissedKeys, setDismissedKeys] = useState<Set<string>>(new Set());
  const agentFileNotifications = useAgentFilesNotifications();

  // Future domains/processes add their hooks here....

  const allNotifications = [
    ...agentFileNotifications,
    // ...someLongTaskNotifications,
  ];

  // Filter out dismissed notifications and add onClose callback to those that don't have one
  return allNotifications
    .filter((notification) => !dismissedKeys.has(notification.key))
    .map((notification) => {
      if (notification.onClose) {
        return notification;
      }
      return {
        ...notification,
        onClose: () => setDismissedKeys((prev) => new Set(prev).add(notification.key)),
      };
    });
};

export default usePersistentNotifications;
